import { render, staticRenderFns } from "./pifaSummary.vue?vue&type=template&id=7ef4e45a&scoped=true&"
import script from "./pifaSummary.vue?vue&type=script&lang=js&"
export * from "./pifaSummary.vue?vue&type=script&lang=js&"
import style0 from "./pifaSummary.vue?vue&type=style&index=0&id=7ef4e45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4e45a",
  null
  
)

export default component.exports